import { Link } from "react-router-dom";
import ArticleBody from "./ArticleBody";
import Breadcrumb from "./Breadcrumb";
import Faq from "./Faq";
import Related from "./Related";
import { formatDate } from "./format";
import "./templates.css";

const TEXT = {
  "en-IN": { by: "Varzish Mate team", updated: "updated", toc: "On this page" },
  "hi-IN": { by: "Varzish Mate team", updated: "अपडेट", toc: "इस पेज पर" },
};

/** Guides, Hindi guides, research and verticals. */
export default function ArticlePage({ entry, chunk }) {
  const t = TEXT[entry.lang] ?? TEXT["en-IN"];
  const hindi = entry.lang === "hi-IN";
  const showToc = chunk && chunk.words > 1200 && chunk.toc?.length > 0;

  return (
    <article className="tpl" lang={hindi ? "hi" : undefined}>
      <div className="container tpl__inner">
        <Breadcrumb entry={entry} />
        <header className="tpl__head">
          <h1 className="t-display-2">{entry.h1}</h1>
          <p className="tpl__byline">
            <Link to="/guides/how-we-write">{t.by}</Link>, {t.updated} {formatDate(entry.updated)}
          </p>
        </header>

        {chunk && (
          <>
            {showToc && (
              <nav className="tpl-toc" aria-label={t.toc}>
                <p className="tpl-toc__title">{t.toc}</p>
                <ol>
                  {chunk.toc.map(({ id, text }) => (
                    <li key={id}>
                      <a href={`#${id}`}>{text}</a>
                    </li>
                  ))}
                </ol>
              </nav>
            )}
            <ArticleBody html={chunk.html} slug={entry.path} lang={entry.lang} />
            <Faq items={chunk.faq} lang={entry.lang} />
            <Related paths={chunk.related} lang={entry.lang} />
          </>
        )}
      </div>
    </article>
  );
}
